import apiFetch from '../../apiFetch'

export default function (dossierId, token, financingStatusId) {
  return apiFetch({ endPoint: `dossier/${dossierId}/FinancingComponentHistorical`, method: 'GET', token: token })
}
